























































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';

@Component
export default class ModalRequisitionForm extends Vue {
  @PropSync('dialogVisibleStatus', { type: Boolean }) syncedDialogVisibleStatus!: boolean;
  @Prop({ type: Object }) ruleForm!: any;
  @Prop({ type: Array }) dataItems!: any;

  public isLoading: boolean = false;

  get sumPrice() {
    return this.dataItems.reduce((p: any, c: any) => p + c.price * c.quantity, 0);
  }

  get sumVat() {
    return this.dataItems.reduce((p: any, c: any) => p + c.price * c.quantity * 0.1, 0);
  }

  get sumTotal() {
    return this.sumPrice + this.sumVat;
  }

  created() {}

  handleClose() {
    this.syncedDialogVisibleStatus = false;
  }

  createPDF() {
    this.isLoading = true;
    let selector: string = '#inner';
    (window as any).html2canvas = html2canvas;
    let pdf: any = new jsPDF();
    let canvas: any = pdf.canvas;
    const pageWidth = 210;
    const pageHeight = 295;
    canvas.width = pageWidth;

    let ele: any = document.querySelector(selector);
    let width = ele.offsetWidth;
    let height = ele.offsetHeight;
    let imgHeight = (pageWidth * height) / width;

    if (!ele) {
      console.warn(selector + ' is not exist.');
      return false;
    }
    html2canvas(ele, {
      scrollX: 0,
      scrollY: 20,
    }).then((canvas: any) => {
      let position = 0;
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow');
      let heightLeft = imgHeight;
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`order_draft${moment().format('YYYY_MM_DD')}` + '.pdf');
      this.isLoading = false;
      this.$message.success('발주서를 생성하였습니다.');
    });
  }
}
